import type { ReactNode } from 'react';

import { useIsMobile } from '@/hooks/useIsMobile';

interface PageLayoutProps {
  children: ReactNode;
  centered?: boolean;
}

export function PageLayout({ children, centered = true }: PageLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        height: '100%',
        overflowY: 'auto',
      }}
    >
      <div
        style={{
          minHeight: '100%',
          display: 'flex',
          alignItems: centered && !isMobile ? 'center' : 'flex-start',
          justifyContent: 'center',
          padding: 'var(--mantine-spacing-xl)',
          paddingTop: isMobile ? '2rem' : 'var(--mantine-spacing-xl)',
          paddingBottom: isMobile ? '2rem' : 'var(--mantine-spacing-xl)',
        }}
      >
        {children}
      </div>
    </div>
  );
}
